function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { AvGroup } from "availity-reactstrap-validation";
import TmLabel from "./components/TmLabel";
import TmFeedback from "./components/TmFeedback";
import TmHelpMessage from "./components/TmHelpMessage";
import HyperDatepicker from "../../theme/Datepicker";
import moment from "moment";

class TmDateInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "generateDateFormat", () => {
      if (this.props.showTimeSelectOnly) {
        return "h:mm a";
      }

      if (this.props.showTimeSelect) {
        return "DD/MM/yyyy h:mm a";
      }

      return "DD/MM/yyyy";
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(TmLabel, this.props), /*#__PURE__*/React.createElement(HyperDatepicker, _extends({
        hideAddon: true,
        dateFormat: this.generateDateFormat()
      }, this.props, {
        value: moment(this.props.value).format(this.generateDateFormat()),
        cypress: this.props.cypress
      })), /*#__PURE__*/React.createElement(TmFeedback, this.props), /*#__PURE__*/React.createElement(TmHelpMessage, this.props));
    });
  }

}

export default TmDateInput;